import { Switch } from "@mui/material";
import styled from "styled-components";

export const ProtheusDominioStyledSwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        content: '""',
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundImage: `url(/thomson_reuters.svg)`,
        backgroundSize: "cover",
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        //   backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
        backgroundColor: "#8796A5",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#fff",
    width: 32,
    height: 32,
    "&:before": {
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      backgroundImage: `url(/totus.svg)`,
      backgroundSize: "cover",
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    //   backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
    backgroundColor: "#8796A5",
    borderRadius: 20 / 2,
  },
}));
